// extracted by mini-css-extract-plugin
export default {"cls1":"UserTooltip-cls1___17d11b047d7a7e6cbda","cls2":"UserTooltip-cls2___ef39a027f296713f035 UserTooltip-cls1___17d11b047d7a7e6cbda"};